const Vue = require('vue').default;

export default Vue.extend({
    data(){
        return {

        }
    },
    methods : {
        getPriceRange(array)
        {
            var min = array[0].price,
                max = array[0].price;

            var range = null;

            array.map((response)=>
            {
                min = response.price < min ? response.price : min
                max = response.price > max ? response.price : max
            });

            min = Number.parseFloat(min).toFixed(2);
            max = Number.parseFloat(max).toFixed(2);

            if(min == max)
            {
                range = "P " + this.numberWithCommas(min);
            }
            else
            {
                range = "P "+ this.numberWithCommas(min) + " - P "+ this.numberWithCommas(max);
            }

            return range
        },
        numberWithCommas(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    }
});
